var _metadata, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKonoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 877.86065 191.90399",
    height: 191.90399,
    width: 877.86066,
    space: "preserve",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    cc: "http://creativecommons.org/ns#",
    dc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement(RDF, null, /*#__PURE__*/React.createElement(Work, {
    about: ""
  }, /*#__PURE__*/React.createElement("format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("type", {
    resource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,1200 H 2000 V 0 H 0 Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient92",
    spreadMethod: "pad",
    gradientTransform: "matrix(278.43967,0,0,-278.43967,857.99817,737.49115)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop78",
    offset: 0.04439189,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop80",
    offset: 0.264045,
    style: {
      stopOpacity: 1,
      stopColor: "#8b878d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop82",
    offset: 0.522472,
    style: {
      stopOpacity: 1,
      stopColor: "#f3f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop84",
    offset: 0.58197592,
    style: {
      stopOpacity: 1,
      stopColor: "#f3f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop86",
    offset: 0.876404,
    style: {
      stopOpacity: 1,
      stopColor: "#807b80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop88",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d1d3d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop90",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d1d3d4"
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath102",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M 0,1200 H 2000 V 0 H 0 Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath114",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "m 857.99,610.623 h 30.912 V 585.4 H 857.99 Z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath130",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 915.811,657.801 h 30.912 v -37.833 h -30.912 z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath146",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 952.282,681.898 h 37.531 v -33.637 h -37.531 z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath162",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "m 997.081,718.456 h 42.679 v -40.321 h -42.679 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-716.28305,630.71305)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(652.9353,330.8448)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#00062e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -78.63,61.822 c -2.193,1.672 -3.573,3.313 -4.154,4.925 -0.58,1.609 -0.869,3.382 -0.869,5.314 0,2.187 0.386,4.119 1.158,5.794 0.775,1.673 2.447,3.479 5.023,5.412 l 74.379,57.185 H 34.58 L -57.38,71.867 37.478,0 Z m -115.723,140.452 h 24.535 V 0 h -24.535 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(778.8972,355.3797)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#00062e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 6.437,0 12.363,1.161 17.774,3.479 5.409,2.318 10.077,5.505 14.007,9.562 3.925,4.056 6.984,8.918 9.176,14.587 2.187,5.665 3.285,11.783 3.285,18.352 0,6.569 -1.098,12.654 -3.285,18.257 -2.192,5.603 -5.251,10.4 -9.176,14.393 C 27.851,82.621 23.183,85.745 17.774,88 12.363,90.25 6.437,91.379 0,91.379 h -34.194 c -6.312,0 -12.143,-1.129 -17.486,-3.379 -5.345,-2.255 -9.947,-5.379 -13.812,-9.37 -3.865,-3.993 -6.892,-8.761 -9.079,-14.296 -2.192,-5.539 -3.284,-11.66 -3.284,-18.354 0,-6.569 1.092,-12.687 3.284,-18.352 2.187,-5.669 5.214,-10.531 9.079,-14.587 3.865,-4.057 8.467,-7.244 13.812,-9.562 C -46.337,1.161 -40.506,0 -34.194,0 Z m -34.194,-24.535 c -9.79,0 -18.838,1.835 -27.145,5.506 -8.307,3.67 -15.522,8.692 -21.636,15.07 -6.12,6.374 -10.885,13.938 -14.296,22.7 -3.416,8.755 -5.119,18.223 -5.119,28.399 0,10.302 1.703,19.704 5.119,28.206 3.411,8.501 8.176,15.744 14.296,21.733 6.114,5.989 13.329,10.625 21.636,13.91 8.307,3.284 17.355,4.928 27.145,4.928 H 0 c 10.174,0 19.478,-1.678 27.917,-5.025 8.432,-3.351 15.679,-8.05 21.733,-14.102 6.052,-6.057 10.754,-13.3 14.104,-21.733 3.348,-8.439 5.023,-17.746 5.023,-27.917 0,-10.176 -1.71,-19.644 -5.12,-28.399 C 60.244,9.979 55.476,2.415 49.361,-3.959 43.241,-10.337 35.998,-15.359 27.628,-19.029 19.252,-22.7 10.045,-24.535 0,-24.535 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(886.5043,433.6238)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#00062e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V -102.779 H -23.377 V 24.726 c 0,4.508 1.126,8.082 3.381,10.723 2.253,2.638 5.312,3.962 9.176,3.962 1.801,0 3.542,-0.386 5.217,-1.161 1.673,-0.772 3.41,-2.061 5.217,-3.862 L 98.72,-63.949 v 102.78 h 23.377 V -89.836 c 0,-4.636 -1.129,-8.244 -3.382,-10.819 -2.255,-2.573 -5.185,-3.862 -8.79,-3.862 -3.993,0 -7.726,1.738 -11.205,5.217 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1126.8308,355.3797)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#00062e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 6.437,0 12.363,1.161 17.775,3.479 5.408,2.318 10.076,5.505 14.006,9.562 3.925,4.056 6.984,8.918 9.176,14.587 2.187,5.665 3.285,11.783 3.285,18.352 0,6.569 -1.098,12.654 -3.285,18.257 -2.192,5.603 -5.251,10.4 -9.176,14.393 C 27.851,82.621 23.183,85.745 17.775,88 12.363,90.25 6.437,91.379 0,91.379 h -34.194 c -6.312,0 -12.143,-1.129 -17.486,-3.379 -5.345,-2.255 -9.947,-5.379 -13.812,-9.37 -3.865,-3.993 -6.892,-8.761 -9.079,-14.296 -2.192,-5.539 -3.284,-11.66 -3.284,-18.354 0,-6.569 1.092,-12.687 3.284,-18.352 2.187,-5.669 5.214,-10.531 9.079,-14.587 3.865,-4.057 8.467,-7.244 13.812,-9.562 C -46.337,1.161 -40.506,0 -34.194,0 Z m -34.194,-24.535 c -9.79,0 -18.838,1.835 -27.145,5.506 -8.307,3.67 -15.522,8.692 -21.636,15.07 -6.12,6.374 -10.885,13.938 -14.296,22.7 -3.416,8.755 -5.119,18.223 -5.119,28.399 0,10.302 1.703,19.704 5.119,28.206 3.411,8.501 8.176,15.744 14.296,21.733 6.114,5.989 13.329,10.625 21.636,13.91 8.307,3.284 17.355,4.928 27.145,4.928 H 0 c 10.174,0 19.478,-1.678 27.917,-5.025 8.432,-3.351 15.679,-8.05 21.733,-14.102 6.052,-6.057 10.754,-13.3 14.104,-21.733 3.348,-8.439 5.023,-17.746 5.023,-27.917 0,-10.176 -1.71,-19.644 -5.12,-28.399 C 60.244,9.979 55.476,2.415 49.361,-3.959 43.241,-10.337 35.998,-15.359 27.628,-19.029 19.252,-22.7 10.045,-24.535 0,-24.535 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1396.1345,330.8448)",
    id: "g42"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1142.0121,561.0649)",
    id: "g56"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g60"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonoLogo);
export default __webpack_public_path__ + "static/media/kono-logo.f3bd54623a9172382d4c001e4de7153e.svg";
export { ForwardRef as ReactComponent };